import { Button } from '@/components';
import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { useStartWorkflow } from '@/features/workflow/hooks/workflow';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  workflowId: string;
};

export const StartWorkflowButton: FC<Props> = ({ workflowId }) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const stackSiderView = useWorkflowStackSiderView();
  const siderConfig = stackSiderView.lastItem?.config;

  const {
    mutateAsync: startInnerWorkflow,
    isPending: isStartInnerWorkflowLoading,
  } = useStartWorkflow({
    projectId:
      siderConfig?.target?.key === 'project'
        ? siderConfig.target.id
        : undefined,
  });

  return (
    <Button
      type="primary"
      loading={isStartInnerWorkflowLoading}
      onClick={async () => {
        await startInnerWorkflow(workflowId);
        openMessage('success', t('message-workflow-started'));
      }}
    >
      {t('workflow-start')}
    </Button>
  );
};
